export default {
  title: {
    login: "%{school} - Logowanie",
    registration: "%{school} - Zarejestrować się",
    subjects: "%{school} - Wybór przedmiotu",
    subject: "%{school} - Przedmiot",
    offer: "%{school} - Oferta",
    home: "%{school} - Strona główna",
    dictionary: "%{school} - Słownik",
    events: "%{school} - Wydarzenia",
    news: "%{school} - Aktualności",
    profile: "%{school} - Profil",
    learn: "%{school} - Nauka",
    pay: "%{school} - Płatność za przedmiot",
    checkInSystem: "Podaj swój E-mail",
    setPassword: "Podaj hasło do logowania.",
    createAccount: "Podaj/sprawdź dane swojego profilu w systemie",
  },
  authCheckEmail: {
    title: "Podaj swój adres e-mail",
    emailCaption: "Adres e-mail",
    continue: "Kontynuuj",
    or: "lub",
  },
  authPassword: {
    title: "Zaloguj się na swoje konto",
    inputCaption: "Hasło",
    placeholder: "Wpisz hasło",
    forgot: "Nie pamiętasz hasła?",
    submit: "Zaloguj się",
  },
  authRegistration: {
    title: "Zarejestruj nowe konto",
    name: "Imię",
    phone: "Numer telefonu",
    password: "Utwórz hasło",
    confirmPassword: "Powtórz utworzone hasło",
  },
  totalError: "Ups, coś poszło nie tak!",
  subjectChangeError: "Nie udało się zmienić przedmiotu. Spróbuj ponownie albo skontaktuj się ze swoją szkołą.",
  email: "E-mail",
  personalLink: "Link osobisty",
  login: "Login",
  name: "Imię",
  firstLastName: "Imię i Nazwisko",
  phone: "Telefon",
  formatPhone: "Numer telefonu w formacie 732...", // for leader-online
  aboutMe: "O mnie",
  fullAge: "Twój wiek (ukończone lata)",
  errorAge: "nieprawidłowy wiek",
  notNumber: "wartość musi być liczbą",
  registration: "Zarejestruj się",
  password: "Hasło",
  currentPassword: "Obecne hasło",
  newPassword: "Nowe hasło",
  confirmPassword: "Powtórz hasło",
  confirmNewPassword: "Powtórz nowe hasło",
  forgotPassword: "Nie pamiętasz hasła?",
  passwordsMatch: "Hasła nie są zgodne",
  resetPassword: "Hasło zostało zresetowane, sprawdź swój E-mail.",
  resetConfirm: "Czy chcesz zresetować hasło?",
  enter: "Zaloguj się",
  studentEnter: "Logowanie dla uczniów",
  check: "Dalej",
  signInWithGoogle: "Zaloguj się przez Google",
  emailIsNotRegistered: "Użytkownik z tym adresem nie istnieje",
  logout: "Wyloguj się",
  online: "online",
  offline: "offline",
  cancel: "Anuluj",
  yes: "Tak",
  no: "Nie",
  course: "Kurs",
  dictionary: "Słownik",
  events: "Wydarzenia",
  news: "Aktualności",
  words: "Słowa",
  wordsAreHere: "Te słowa znajdują się tutaj:",
  allWords: "Wszystkie słowa",
  phrases: "Zwroty",
  videos: "Wideo",
  exercises: "Ćwiczenia",
  theory: "Teoria",
  theoryAlt: "Notatka",
  theoryAdditionalFile: "Pobierz dodatkowy plik (%{filename})",
  lessons: "Lekcje",
  topic: "Temat",
  lesson: "Lekcja",
  profile: "Profil",
  orders: "Zakupy",
  payment: "Płatności",
  leaderboard: "Liderzy",
  leaderboardPerDay: "Dzisiejsi liderzy",
  time: "Czas",
  points: "Punkty",
  myPoints: "Moje punkty za cały okres",
  coins: "Monety",
  courses: "Moje kursy",
  loading: "Ładowanie...",
  noTheory: "Do tej lekcji nie ma teorii.",
  startTraining: "Rozpocznij trening",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Rozpocznij czat",
    startDialogTooltip: "Utwórz nowy dialog",
    messages: "Wiadomości",
    unreadOnly: "Tylko nieprzeczytane",
    delete: "Usuń",
    send: "Wyślij",
    sendHelper: "Ctrl+Enter — aby wysłać wiadomość",
    close: "Zamknij",
    profile: "Profil",
    lastActivity: "Ostatnia aktywność",
    status: "Status",
    jobTitle: "Nazwa stanowiska",
    tabLabel: "Czat",
    lastOnline: {
      time: "Był(a) online o %{date}",
      weekday: "Był(a) online w %{date}",
      dayMonth: "Był(a) online %{date}",
      monthYear: "Był(a) online w %{date}",
    },
    read: "Przeczytano",
    errors: {
      wrongFormatting: "Wiadomość zawiera nieprawidłowe formatowanie",
    },
  },
  branches: "Sekcje",
  easy: "Łatwo",
  expert: "Ekspert",
  wordToLearn: "Naucz się później",
  iKnowWord: "Znam to słowo",
  videoVocabulary: "Leksyka z wideo",
  markVideoWatched: "Oznacz jako obejrzane",
  videoWatched: "Obejrzane",
  passed: "ukończono",
  unsupportedExercise: "Ten typ ćwiczeń (%{type}) nie jest jeszcze obsługiwany",
  changeCourse: "Zmień kurs",
  currentCourse: "Aktualny kurs",
  allSubjects: "Wszystkie przedmioty",
  all: "Wszystkie",
  subject: "Przedmiot",
  group: "Grupa",
  start: "Rozpocznij",
  chooseSubject: "Wybierz przedmiot, którego chcesz się uczyć",
  hourValue: "%{value} godz.",
  completed: "Ukończony",
  notCompleted: "Nieukończony",
  paidBranch: "Płatny temat. Dostęp wymaga płatności.",
  buyBranch: "Kup temat za %{price} %{currency}",
  paidSubject: "Płatny przedmiot. Dostęp wymaga płatności.",
  buySubject2: "Kup przedmiot za %{price} %{currency}",
  decksItemNotOpen: "Aby otworzyć tę lekcję, musisz ukończyć poprzednią lekcję",
  decksItemNotPurchasedBranch: "Temat tej lekcji nie został jeszcze kupiony",
  decksItemNotOpenLevel: "Aby otworzyć tę lekcję, należy ukończyć poprzedni poziom",
  decksItemNotOpenBranch: "Aby otworzyć tę lekcję, musisz ukończyć poprzedni temat",
  deckAccessDenied: "Ta lekcja nie jest jeszcze dla Ciebie dostępna",
  openOnDate: "otworzy się %{date}",
  levelAccessIsDenied: "Materiały tego poziomu nie są dla Ciebie dostępne",
  youAreDeactivated: "Twoje konto zostało dezaktywowane, skontaktuj się ze swoją szkołą",
  youAreDeactivatedShort: "Twoje konto zostało dezaktywowane",
  youAreHaveNotPaidOffers: "Masz nieopłacone oferty",
  yourCertificates: "Twoje certyfikaty",
  emptyDeck: "Lekcja jest pusta",
  nextDeck: "Następna lekcja",
  next: "Dalej",
  proceed: "Kontynuuj",
  skip: "Pomiń",
  more: "Więcej",
  exit: "Wyjście",
  details: "Więcej szczegółów",
  go: "Przejdź",
  profileEdit: "Edytuj profil",
  userInfo: "Informacje o użytkowniku",
  of: "z",
  back: "Wstecz",
  levelPackExist: "Masz już ten zestaw poziomów",
  awaitingPayment: "Oczekuje na płatność",
  bought: "Kupiony",
  boughtUntilDate: "Kupiony do %{endDate}",
  availableUntilDate: "Dostępny do %{endDate}",
  showMore: "pokaż więcej",
  hide: "zwiń",
  communication: "Kontakt ze szkołą",
  askQuestion: "Zadaj pytanie",
  noDescription: "Brak opisu",
  description: "Opis:",
  onePerMonth: "Raz w miesiącu",
  semiannually: "Raz na pół roku",
  onceAYear: "Raz w roku",
  stopSubscribe: "Zatrzymaj subskrypcję",
  enable: "Włącz subskrypcję",
  expired: "Termin minął",
  buySubject: "Kup przedmiot",
  buyOffer: "Kup",
  subscribeOffer: "Subskrybuj",
  firstPayment: "Pierwsza płatność",
  accessDaysWarning: "Pozostał %{smart_count} dzień |||| Pozostało %{smart_count} dni",
  accessDemoDaysWarning: "Demo: pozostał %{smart_count} dzień |||| Demo: pozostało %{smart_count} dni",
  accessDemoButton: "Dostęp demo",
  closeButton: "Zamknij",
  existOffer: "Istnieje już nieopłacona oferta",
  loginInProcess: "Trwa logowanie...",
  done: "Ukończono:",
  Levels: {
    empty: "W tym kursie nie ma jeszcze dostępnych poziomów.",
    name: "Poziom:",
  },
  Decks: {
    scormPass: "Zaliczyć lekcję",
    proceed: "Dalej",
    stayHere: "Zostań tutaj",
  },
  Exercises: {
    tabTitle: "Ćwiczenia",
    skip: "Dalej",
    check: "Sprawdź",
    examCheck: "Wyślij",
    typeAnswer: "Wpisz odpowiedź",
    next: "Dalej",
    rightAnswerWas: "Prawidłowa odpowiedź to:",
    showRightAnswer: "Pokaż prawidłową odpowiedź",
    rightAnswer: "Prawidłowa odpowiedź:",
    congratulation: "Gratulacje!",
    congratText: "Opanowałeś/opanowałaś wszystkie ćwiczenia w tej lekcji!",
    wrongAnswer: "Twoja odpowiedź jest nieprawidłowa",
    answerSaved: "Odpowiedź zapisana",
    commentToAnswer: "Komentarz do wybranej odpowiedzi:",
    appendix: {
      pdf: {
        tooltipButton: "Dodatkowe materiały",
      },
    },
    type13: {
      title: "Uzupełnij luki, wybierając odpowiednie słowo z listy rozwijanej",
    },
    type12: {
      title: "Zapoznaj się z dodatkowymi informacjami",
    },
    type11: {
      title: {
        select: "Wybierz prawidłową odpowiedź",
        keyboard: "Wpisz prawidłową odpowiedź",
      },
    },
    type9: {
      title: {
        select: "Uzupełnij luki, wybierając odpowiednie słowo",
        keyboard: "Uzupełnij luki",
      },
    },
    type8: {
      title: "Dopasuj pary",
    },
    type7: {
      title: {
        text: "Napisz swoją odpowiedź",
        audio: "Nagraj odpowiedź audio ",
      },
      recordingIsNotSupported: "Nagrywanie dźwięku nie jest obsługiwane przez Twoją przeglądarkę.",
      audioRecordingError: "Błąd nagrywania dźwięku: ",
      inputLabel: "Twoja odpowiedź",
      addPhotoVideo: "Dodaj zdjęcie/wideo (do %{maxCount} szt.)",
      addPhoto: "Dodaj zdjęcie (do %{maxCount} szt.)",
      cameraInitialization: "Inicjalizacja...",
      change: "Zmień",
      codeToApprove: "Hasło",
      homework: {
        teacherData: {
          audio: "Komentarz audio nauczyciela",
          audioComment: "Komentarz głosowy nauczyciela",
        },
      },
      addFiles: "Dodaj pliki",
      limitsHelperText: "Długość tekstu musi wynosić co najmniej %{count} znaków",
      photoRequired: "Dołącz co najmniej jedno zdjęcie lub plik do swojej odpowiedzi",
      photoViewerHint: "Możesz przybliżać obrazek kółkiem myszy",
    },
    type6: {
      title: "Narysuj element",
      checkButtonText: "Rozumiem!",
    },
    type3: {
      title: "Ułóż tutaj elementy we właściwej kolejności",
      hint: "Przeciągnij tutaj elementy znajdujące się poniżej",
    },
    type5: {
      title: "Wybierz elementy",
      hint: "Wybierz odpowiednie elementy w dolnej części ekranu (aby wybrać, po prostu je kliknij)",
    },
    type2: {
      title: "Wybierz brakujące słowo",
    },
  },
  Events: {
    headNotice: "Czas wydarzenia jest wyświetlany zgodnie z Twoją strefą czasową",
    title: "Wydarzenia w tym tygodniu",
    startTime: "Godzina rozpoczęcia",
    finishTime: "Godzina zakończenia",
    group: "Grupa",
    persons: "%{smart_count} uczeń |||| %{smart_count} uczniów",
    leader: "Prowadzący",
    tag: "Kategoria",
    joinedCheckbox: "Z rejestracją",
    joined: "Wybrano:",
    interested: "Zarejestruj się",
    registered: "Zarejestrowano",
    enter: "Zaloguj się",
    limitPopupInfo: "Osiągnięto limit rejestracji na wydarzenia",
    eventHasStarted: "Wydarzenie już się rozpoczęło!",
    registrationNotice: "Rejestracja zakończona pomyślnie! Przycisk wejścia będzie aktywny o %{date_and_time}. Po tym czasie nie będzie można anulować rejestracji na wydarzenie",
    registrationNoticeNoUrl: "Rejestracja zakończona pomyślnie! Po %{date_and_time} nie będzie można anulować rejestracji na wydarzenie",
    cancelRegistration: "Czy na pewno chcesz anulować rejestrację?",
    calendarLink: "Dodaj wydarzenie do Kalendarza Google",
    status_planned: "Zaplanowano",
    status_started: "Rozpoczęto",
    status_completed_successfully: "Zakończono",
    status_last_minute_cancellation: "Anulowano w ostatniej chwili",
    status_late_cancellation: "Późne anulowanie",
    status_canceled: "Anulowano",
    status_moved: "Przeniesiono",
  },
  statistic: {
    title: "Statystyka",
    points: "Punkty",
    phrases: "Zwroty",
    missions: "Misje",
    words: "Słowa",
    time: "Czas",
  },
  status: {
    wait_review: "Oczekuje na sprawdzenie",
    on_review: "W trakcie",
    approved: "Zaakceptowano",
    not_approved: "Odrzucono",
    not_approved_allow_update: "Odrzucono (można poprawić)",
    ai_reviewed: "Sprawdzone za pomocą AI",
  },
  homeworks: {
    tabName: "Zadania",
    todo: "Do wykonania",
    done: "Wykonane",
    topic: "Temat",
    lesson: "Lekcja",
    onlyInMobileApp: "Dostępne tylko w aplikacji mobilnej",
    todoHomework: "ZADANIE W TRAKCIE SPRAWDZANIA",
    postToDoButton: "Wyślij",
    types: {
      homework_todo: "ToDo",
      exercise: "Ćwiczenie",
    },
    waitAIReview: "Poczekaj, AI sprawdza odpowiedź",
    dontWait: "nie czekać",
    checkingHomework: "Sprawdzam pracę domową",
  },
  exam: {
    popupTitle: "Lekcja z egzaminem",
    popupDescr1: "To lekcja z egzaminem. Najpierw zapoznaj się ze wszystkimi dodatkowymi materiałami, a dopiero potem przejdź do wykonywania ćwiczeń.",
    popupDescr2: `Gdy tylko przejdziesz do zakładki "Ćwiczenia", rozpocznie się odliczanie czasu.`,
    popupDescr3: 'Zakładki "Teoria" i "Wideo" NIE uruchamiają odliczania czasu egzaminu.',
    cancelButton: "Następnym razem",
    positiveButton: "Rozumiem (%{smart_count} próba)  |||| Rozumiem (%{smart_count} próby)",
    questions: "%{smart_count} pytanie |||| %{smart_count} pytań",
    oneAttempt: "Jedna próba na odpowiedź",
    timeLimit: "Limit czasu: %{limit} minut",
    noPause: "Egzaminu nie można wstrzymać",
    progress: "Pytanie nr %{current} z %{total}",
    closeButton: "Zamknij",
    viewButton: "Zobacz wyniki",
    retakeButton: "Spróbuj ponownie (%{smart_count} próba)  |||| Spróbuj ponownie (%{smart_count} próby)",
    finishedPopupTitle: "Wyniki egzaminu",
    examPassed: "Egzamin zdany pomyślnie",
    examNotPassed: "Egzamin niezdany",
    waitHomeworks: "%{smart_count} pytanie w trakcie sprawdzania |||| %{smart_count} pytań w trakcie sprawdzania",
    result: "Twój wynik:",
  },
  subjects: {
    unavailable: "Przedmiot jest obecnie niedostępny",
  },
  orderStatus: {
    approved: "Pomyślnie",
    canceled: "Anulowano",
    pending: "Oczekuje",
  },
  notificationsTypes: {
    event: "Wydarzenie",
    invoice: "Faktura",
    news: "Aktualność",
    homework: "Zadania",
    homework_todo: "Zadanie Todo",
    type: {
      exercise: "Zadania",
      homework_todo: "Zadania To do",
    },
  },
  notificationsAlert: {
    subscribe: "Włącz powiadomienia",
    unsubscribe: "Wyłącz powiadomienia",
    instructions: "Kliknij kłódkę 🔒 po lewej stronie paska adresu i zmień uprawnienia powiadomień zgodnie z obrazkiem albo zmień ogólne ustawienia przeglądarki.",
    permissionDefault: {
      title: "Włącz powiadomienia 🔔",
      body: "Powiadomienia o zmianie statusu pracy domowej, rozpoczęciu wydarzenia, aktualnościach i nowych zadaniach do wykonania. Bez reklam — tylko informacje o Twojej nauce!",
    },
    permissionDenied: {
      title: "Powiadomienia są teraz wyłączone ❌",
      body: "Wcześniej zrezygnowałeś/zrezygnowałaś z powiadomień. Bez nich nie możesz na czas dowiadywać się o zmianie statusu pracy domowej i rozpoczęciu wydarzenia. Aby włączyć powiadomienia, postępuj zgodnie z instrukcją poniżej:",
    },
    permissionGranted: {
      title: "Powiadomienia są teraz włączone ✔",
      body: "Czy na pewno chcesz zrezygnować z powiadomień? Bez nich nie możesz na czas dowiadywać się o zmianie statusu pracy domowej i rozpoczęciu wydarzenia. Aby wyłączyć powiadomienia, postępuj zgodnie z instrukcją poniżej:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Wyślij opinię",
    placeholder: "Podziel się swoimi wrażeniami",
    defaultInstruction: "Użyj suwaka, aby ocenić",
    eventInstruction: "Oceń zakończone wydarzenie",
    submitError: "Wybierz ocenę",
    submitSuccess: "Dziękujemy! Twoja opinia została pomyślnie wysłana",
    wasNotPresent: "Nie uczestniczyłem/uczestniczyłam w wydarzeniu",
    dateOfEvent: "Data wydarzenia:",
  },
  congratulation: {
    mission: "Gratulacje, misja %{name} została ukończona!",
    missionTask: {
      title: "🎉 Gratulacje! Zadanie %{name} zostało wykonane.",
      content: "Do ukończenia misji pozostało <b>%{need} zadań</b> — kontynuuj w tym samym duchu!",
    },
  },
  accountNotFound: "Ten adres E-mail nie jest powiązany z żadną przestrzenią edukacyjną. Skontaktuj się z administratorem swojej szkoły",
  demoAccess: "Chcesz wypróbować SkillzRun dla swojej firmy/szkoły? Zarejestruj się, aby przetestować platformę",
  structure: "Struktura",
  version: {
    message: "Dostępna jest nowa wersja aplikacji. Odśwież stronę, aby zaktualizować",
    button: "Odśwież",
  },
  missions: {
    title: "Misje",
    startButton: "Start misji",
    missionStarted: "Misja rozpoczęta %{started}",
    started: "Misja rozpoczęta!",
    tasks: {
      title: "Szczegóły zadania",
    },
  },
  productCatalog: {
    title: "Katalog produktów",
    coinBalance: "Twoje saldo:",
    notEnoughCoins: "Za mało monet",
    order: "Zamów",
    orderConfirmation: "Potwierdzenie zamówienia",
    price: "Cena:",
    remaining: "Pozostało:",
    instructionForForm: "Aby przyspieszyć realizację zamówienia, uzupełnij dane do odbioru",
    address: "Adres",
    thankText: "Dziękujemy! Twoje zamówienie zostało złożone",
    pleaseWait: "Poczekaj, skontaktuje się z Tobą menedżer",
    pleaseWaitPersona: "Oczekuj SMS-a. Otrzymasz numer przesyłki.",
    thankTextOffer: "Dziękujemy! Zakup został zrealizowany.",
    contentAvailableText: "Treść jest już dostępna — możesz z niej korzystać od razu.",
    deliveryAddress: "Wpisz adres dostawy",
    helperText: "Podaj pełny adres albo miasto i numer oddziału Nowej Poczty/Ukrpoczty",
    deliveryOptions: "*Opcje dostawy zostaną ustalone z menedżerem po otrzymaniu zamówienia.",
    validationPhoneFormat: "Numer telefonu musi mieć 10 cyfr i zaczynać się od 0.",
    recipientNameLabel: "Imię i nazwisko",
    recipientNameRequired: "Wpisz imię odbiorcy.",
    npCityRequired: "Wybierz miasto dostawy.",
    npWarehouseRequired: "Wybierz oddział Nowej Poczty.",
    npCityLabel: "Miasto Nowej Poczty",
    npCityPlaceholder: "Zacznij wpisywać nazwę miasta",
    npCitySearching: "Wyszukiwanie miast...",
    npCitySelectHint: "Wybierz miasto z listy",
    npCityTypeHint: "Zacznij wpisywać nazwę miasta (min. 3 znaki)",
    npBranchTypeDepartments: "Oddziały",
    npBranchTypePostomats: "Paczkomaty",
    npWarehouseLabel: "Oddział Nowej Poczty",
    npWarehousePlaceholder: "Wybierz oddział",
    npWarehouseLoading: "Ładowanie oddziałów...",
    npWarehouseSelectHint: "Wybierz oddział z listy",
    npWarehouseEmpty: "Dla tego miasta nie znaleziono oddziałów",
    npWarehouseCityFirst: "Najpierw wybierz miasto",
    inProcessing: "W realizacji",
    purchased: "Kupiono",
    oneTimeAlreadyPurchased: "Ten produkt został już kupiony",
  },
  companyReviewTitle: "Na ile prawdopodobne jest, że polecisz naszą szkołę znajomemu lub przyjacielowi?",
  companyReviewText: 'Oceń w skali od 1 do 10, gdzie 1 oznacza "zdecydowanie nie polecę", a 10 — "zdecydowanie polecę"',
  subjectReviewTitle: "Na ile interesujące było dla Ciebie przechodzenie tego kursu na platformie",
  subjectReviewText: 'Oceń w skali od 1 do 10, gdzie 1 oznacza "wcale nieciekawe", a 10 — "bardzo ciekawe"',
  policySettings: {
    termsAndConditions: "Warunki korzystania z serwisu",
    refund: "Polityka prywatności",
  },
  promoCode: "Kod promocyjny",
  promoInvalid: "Kod promocyjny jest nieprawidłowy",
  lessonsCount_one: "%{smart_count} lekcja",
  lessonsCount_few: "%{smart_count} lekcje",
  lessonsCount_many: "%{smart_count} lekcji",
};
